<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>类目名称：</label>
                <el-input v-model="search_Obj.f_name" clearable></el-input>
            </div>
            
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <div class="djBox" v-if="parents && parents.length>0">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item><span class="pppp" @click="toChild1(0)">最上级</span></el-breadcrumb-item>
                    <el-breadcrumb-item v-for="p in parents.slice().reverse()" :key="'p'+p.id"><span class="pppp" @click="toChild1(p.id)">{{p.name}}</span></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="name" label="分类名称" sortable="custom">
                    <!-- <template slot-scope="scope">
                        <template v-if="scope.row.pid == 0">
                            <el-button type="text" size="small" @click="toChild(scope.$index, scope.row)" class="font1">{{scope.row.name}}</el-button>
                        </template>
                        <template v-else>
                            <span>{{scope.row.name}}</span>
                        </template>
                    </template> -->
                </el-table-column>
                <el-table-column prop="order_index" label="排序" sortable="custom" width="120px"></el-table-column>
                <el-table-column prop="is_show" label="是否显示" sortable="custom" width="140px">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.is_show, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            :pid="pid"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看商品类目"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import { getListData } from '@/api/common'
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'goodsCateList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '商品类目',
            menu_id: 7300,
            list_url: "/api/admin/goodscate/list",
            search_Obj: {
                f_name: '',
                f_pid: '0',
            },
            del_Obj:{
                url:'/api/admin/goodscate/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['yesNo'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            pid: 0,
            parents: []
        };
    },
    methods: {
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.parents = res.data.parents;
                }
            })
        },
        toChild(index, row){
            this.search_Obj.f_pid = row.id
            this.pid = row.id
            this.getData()
        },
        toChild1(pid){
            this.search_Obj.f_pid = pid
            this.pid = pid
            this.getData()
        }
    }
};
</script>

<style lang="less" scoped>
    .font1{
        font-weight: normal;
    }
    .djBox {
        margin-bottom: 20px;
        .pppp {
            cursor: pointer;
        }
    }
</style>